import { AbsoluteFill, Img, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
import { useEffect } from "react";

interface SeccionInterface {
	title: string,
	name: string,
	text: string
}

export const HolaSection = ({
	title,
	name,
	text
}: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps } = useVideoConfig();
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);

	// ? EFECTO CAMBIO DE SECCION
	const scaleSection = spring({
		fps,
		frame,
		config: { damping: 400, stiffness: 400 },
		from: 1,
		to: 3,
		delay: (durationInFrames - 8)
	});
	const blurSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 6,
		delay: (durationInFrames - 8)
	});

	// ? TITLE

	const titleBlockTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 50,
		to: 40,
		delay: 75
	});

	const titleRotateAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 960,
		to: 0,
		delay: 0
	});
	const titleScaleAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});
	const titleOpacityAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});

	const subtitleOpacityAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 20
	});

	const subtitleTranslateAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 20,
		to: 0,
		delay: 20
	});

	// ? LOGO

	const logoOpacityAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 50
	});
	const logoScaleAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 50
	});
	const logoTranslateAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 50
	});

	// ? PARRAFO

	const parrafoOpacityAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 75
	});
	const parrafoScaleAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 75
	});
	const parrafoTranslateAnimation = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 75
	});
	return (
		<AbsoluteFill style={{
			filter: (blurSection > 0) ? `blur(${blurSection}px)` : '',
			transform: `scale(${scaleSection})`
		}}>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D",
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="text" style={{
					position: "absolute",
					top: `${titleBlockTranslate}%`,
					left: "50%",
					textAlign: "center",
					transform: "translate(-50%, -50%)",
				}}>
					<h1 style={{
						position: "relative",
						fontSize: 172,
						fontWeight: 900,
						color: "#fff",
						margin: 0,
						opacity: titleOpacityAnimation,
						lineHeight: 0.8,
						marginBottom: 20,
						textAlign: "center",
						textTransform: "uppercase",
						transform: `rotate(${titleRotateAnimation}deg) scale(${titleScaleAnimation})`
					}}>{title}<span style={{
						color: "#000"
					}}>!</span></h1>
					<h4 style={{
						fontSize: 90,
						margin: 0,
						opacity: subtitleOpacityAnimation,
						color: "#fff",
						fontWeight: 500,
						lineHeight: 0.8,
						transform: `translateY(${subtitleTranslateAnimation}%)`
					}}>{name}</h4>
				</div>
				<div className="text-news" style={{
					position: "absolute",
					bottom: 140,
					width: "100%",
					textAlign: "center",
				}}>
					<p style={{
						position: "relative",
						margin: 0,
						fontSize: 90,
						color: "#fff",
						fontWeight: 500,
						opacity: parrafoOpacityAnimation,
						transform: `translateY(${parrafoTranslateAnimation}%) scale(${parrafoScaleAnimation})`
					}}>Te tenemos una gran noticia</p>
					<div className="logo" style={{
						position: "relative",
						marginTop: 20,
						opacity: logoOpacityAnimation,
						transform: `translateY(${logoTranslateAnimation}%) scale(${logoScaleAnimation})`
					}}>
						<Img className="logo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg")} style={{
							display: "block",
							width: "100%",
							margin: "auto",
							maxWidth: 316
						}} />
					</div>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};